import axios from 'axios';
import API from '../config/API';

export const communityService = {
    getCommunityPosts,
    publishCommunityPost,
    unpublishCommunityPost,
}
const headersApplicationJson = {
  "Content-Type": "application/json",
};

function getCommunityPosts(params) {
    return axios.get(`${API.GET_COMMUNITY_POSTS}/${params}`);
}

function publishCommunityPost(params) {
  return axios.put(API.PUBLISH_COMMUNITY_POST(params.postId), params, {
    headers: headersApplicationJson,
  });
}

function unpublishCommunityPost(params) {
  return axios.put(API.UNPUBLISH_COMMUNITY_POST(params.postId), params, {
    headers: headersApplicationJson,
  });
}
